module.exports = __webpack_public_path__ + "static/media/cronos-color.a5534baf.svg";